import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants/Routes';

/**
 * Linear gradient (top white → bottom gray) at 50% opacity + light backdrop blur,
 * with plan copy and Manage Subscription. Blocks interaction with content below except the button.
 */
const RestrictedChartOverlay = ({ className = '' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={`absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 p-4 ${className}`}>
      <div
        className="absolute inset-0 pointer-events-auto"
        style={{
          background: 'rgba(214, 214, 214, 0.2)',
          backdropFilter: 'blur(17.5px)',
          WebkitBackdropFilter: 'blur(17.5px)',
        }}
        aria-hidden
      />
      <div className="relative z-10 flex flex-col items-center gap-3 text-center px-2 max-w-sm pointer-events-none">
        <div className="flex flex-col items-center gap-1 w-full">
          <p className="text-sm font-medium text-[#282A29] dark:text-white">
            {t('analytics.chartLocked.line1')}
          </p>
          <p className="text-sm font-medium text-[#282A29] dark:text-white">
            {t('analytics.chartLocked.line2')}
          </p>
        </div>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigate(ROUTES.SUBSCRIPTION);
          }}
          className="pointer-events-auto bg-bloom-green hover:bg-bloom-green-hover text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm"
        >
          {t('billing.manageSubscription', 'Manage subscription')}
        </button>
      </div>
    </div>
  );
};

export default RestrictedChartOverlay;
